import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { Engagement } from "@oysterhr/schema"
import { PLAN_CONTRIBUTION_SETTINGS_FRAGMENT } from "~/shared/fragments/PlanContributionSettingFragment"

export const INITIAL_ENGAGEMENT_QUERY = gql`
  ${PLAN_CONTRIBUTION_SETTINGS_FRAGMENT}
  query BenefitsStaffSelectedEngagementPlanData($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      role
      teamMemberName
      countryCode
      teamMember {
        id
      }
      availableBenefitPlans {
        collection {
          id
          name
          category
          dependentsConfig
          costSplitAllowed
          provider {
            name
          }
          priceEstimate {
            currencies {
              currencyCode
              subunit
              subunitToUnit
            }
          }
          ...PlanContributionSettingFragment
        }
      }
      company {
        id
        paymentCurrencyCode
      }
    }
  }
`

export function useEngagementPlanData(engagementId: string) {
  return useQuery<{ engagement: Engagement }>(INITIAL_ENGAGEMENT_QUERY, {
    variables: { engagementId },
    fetchPolicy: "no-cache",
  })
}
